module.exports = __webpack_public_path__ + "img/134.044eac5.jpg";